import Popover from 'emerald-ui/lib/Popover';
import Icon from 'emerald-ui/lib/Icon';
import OverlayTrigger from 'emerald-ui/lib/OverlayTrigger';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Popover, componentName: 'Popover' }], 'Popover'),
  description:
    'A Popover is a small container that appears relative to another element, mainly a trigger, like a Button. It can work as a tooltip, too.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Popover, Icon, OverlayTrigger },
      code: `<div style={{ height: '250px', position: 'relative' }}>
  <Popover
    title="Popover"
  >
    Sed posuere consectetur est at lobortis. Aenean eu leo quam.
    Pellentesque ornare sem lacinia quam venenatis vestibulum.
  </Popover>
</div>`,
    },
  ],
};
